function assignCuratedBundlesEvents() {
  const select_elem = document.querySelectorAll('.curated-bundle-card select.cb-select-variation');
  const add_to_cart_btn = document.querySelectorAll('.curated-bundle-card button.add-curated-bundle-to-cart');


  function formatToPrice(priceInCents, forceDecimals) {
    const currencyFormats = {
      USD: { symbol: '$',  decimal: '.', thousand: ',', prepend: true },
      CAD: { symbol: '$',  decimal: '.', thousand: ',', prepend: true },
      MXN: { symbol: '$',  decimal: '.', thousand: ',', prepend: true },
      AUD: { symbol: '$',  decimal: '.', thousand: ',', prepend: true },
      NZD: { symbol: '$',  decimal: '.', thousand: ',', prepend: true },
      EUR: { symbol: '€',  decimal: ',', thousand: '.', prepend: true },
      GBP: { symbol: '£',  decimal: '.', thousand: ',', prepend: true },
      NOK: { symbol: 'kr', decimal: ',', thousand: '.', prepend: false },
      SEK: { symbol: 'kr', decimal: ',', thousand: '.', prepend: false },
      DKK: { symbol: 'kr', decimal: ',', thousand: '.', prepend: false }
    };

    const current_store_currency = Shopify.currency.active; // AUD, USD, EUR, NOK, ...
    const currency = currencyFormats[ current_store_currency ];
    if (!currency) {
      return 'currency not supported';
    }
    
    let price = priceInCents / 100;
    let parts = price.toFixed(2).split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1] || '';

    // Format the integer part with thousand separators
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, currency.thousand);

    // Decide whether to force decimals
    if (forceDecimals || decimalPart.length > 0) {

      if (currency.prepend) {
        return `${currency.symbol}${integerPart}${currency.decimal}${decimalPart}`; // €19.00
      } else {
        return `${integerPart}${currency.decimal}${decimalPart} ${currency.symbol}`;// 19.00 kr
      }
    } else {
      if (currency.prepend) {
        return `${currency.symbol}${integerPart}`; // $19
      } else {
        return `${integerPart} ${currency.symbol}`; // 19 kr
      }
    }
  } //END formatToPrice()


  function updateProductVariant(BundleID, ProductID, VariantID) {
    var new_product_variant = null;
    var bundle_discount_mod = 1; 

    // console.log('bundle', BundleID);
    // console.log('product', ProductID);
    // console.log('variant', VariantID);

    // find the product/variant
    curated_bundles.curated_bundles.forEach(function(bundle) {
      if (bundle.bundle_id == BundleID) {
        let bundle_cost = 0;

        bundle.products.forEach(function(product) {
          if (product.id == ProductID) {
            product.variant.forEach(function(variant) {
              if (variant.id == VariantID) {
                new_product_variant = variant;
              }
            });
          }

          bundle_cost += product.price
        });

        bundle_discount_mod = bundle.discount;
      }
    });

    if (new_product_variant) {

      // save the selected product variant
      user_curated_bundles[BundleID].products[ProductID].variant = new_product_variant.id;
      user_curated_bundles[BundleID].products[ProductID].price = new_product_variant.price;
      user_curated_bundles[BundleID].price = 0;

      // save total price for the bundle 
      for (const [product_id, product] of Object.entries(user_curated_bundles[BundleID].products)) {
        user_curated_bundles[BundleID].price += product.price;
      }

      // update product preview
      var product_card_elem =  document.querySelector('[data-bundle="' + BundleID + '"][data-bundle-product="' + ProductID + '"]');
      product_card_elem.setAttribute('data-bundle-variant', new_product_variant.id);
      product_card_elem.querySelector('img[data-bundle-product-image]').setAttribute('src', new_product_variant.image_url);
      product_card_elem.querySelector('[data-price]').innerHTML = new_product_variant.price_with_currency;
      
      // update bundle price (show original and discounted price)
      var price_html = '';
      if (bundle_discount_mod == 1) {
        price_html += 'Total: ' + formatToPrice( user_curated_bundles[BundleID].price, true );
      } else {
        price_html += '<span class="price-strikethrough">' + formatToPrice( user_curated_bundles[BundleID].price, true ) + '</span> ';
        price_html += '<span class="price-special">' + formatToPrice( user_curated_bundles[BundleID].price * bundle_discount_mod, true ) + '</span>';
      }
      document.querySelector('[data-curated-bundle-id="' + BundleID + '"] [data-curated-bundle-price]').innerHTML = price_html;
    }
  } //END updateProductVariant()


  function onVariantChange(e) {
    var bundle_id = e.srcElement.closest('.cb-product-card').getAttribute('data-bundle');
    var product_id = e.srcElement.closest('.cb-product-card').getAttribute('data-bundle-product');
    var variant_id = e.srcElement.value;

    updateProductVariant(bundle_id, product_id, variant_id);
  } //END onVariantChange()


  function onAddtoCart(e) {
    var curated_bundle = user_curated_bundles[ e.srcElement.dataset.curatedBundleId ];
    var payload = {
      "items": []
    };

    e.preventDefault();

    if (!curated_bundle) return false; 

    for (const [id, product] of Object.entries( curated_bundle.products )) {
      payload.items.push({
        "id": product.variant,
        "quantity": product.quantity
      });    
    }
        
    if (payload.items.length == 0) return false;

    // add curated bundle items to ajax cart
    liquidAjaxCart.cartRequestAdd(payload);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'add_curated_bundle_to_cart',
      'bundle_name': curated_bundle.name
    });
  } //END onAddtoCart()


  // on select variant change
  select_elem.forEach(function(elem) {
    elem.addEventListener("change", onVariantChange);
  });

  // on cta btn click
  add_to_cart_btn.forEach(function(elem) {
    elem.addEventListener('click', onAddtoCart);
  });
} //END assignCuratedBundlesEvents()


function initCuratedBundlesCarousel() {
  const swiper_slides = document.querySelectorAll('.swiper.swiper-curated-bundles .swiper-slide');
  if (swiper_slides.length == 0) return false;

  const swiper = new Swiper('.swiper.swiper-curated-bundles', {
    direction: 'horizontal',
    loop: true,
    pagination: {
      el:           '.swiper-pagination',
      type:         'bullets',
      clickable:    true,
      renderBullet: function (index, className) {
        const slide_title = swiper_slides[index].getAttribute('data-swiper-slide-title');
        return '<span class="' + className + '">' + slide_title + '</span>';
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }      
  });
} //END initCuratedBundlesCarousel()


window.addEventListener('DOMContentLoaded',function () {
  initCuratedBundlesCarousel();
  assignCuratedBundlesEvents();
});